































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CvValue } from '@/models'

// code_id is the varchar(100) PK, admin-provided: letters, digits, '-' and '_'.
const CODE_ID_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/

function emptyForm(typeId: string): CvValue {
  return {
    // Pre-fill the code_id with the "<typeId>-" prefix so the admin just appends the value code.
    codeId: typeId ? `${typeId}-` : '',
    typeId,
    name: '',
    code: '',
    shortCode: '',
    pcmId: '',
    pcmLabel: '',
    metadata: '',
    notes: null,
    relatedTo: null,
    orderNum: null,
    editorialProjectsId: null,
    childrenElementTypeAllowed: null,
    icon: null
  }
}

@Component
export default class UpsertCvValueModal extends Vue {
  @Prop({ required: false }) value: CvValue | null
  @Prop({ required: true }) typeId: string

  private form: CvValue = emptyForm('')

  private saving = false

  @Watch('value', { deep: true })
  @Watch('typeId')
  onInputChanged() {
    this.form = this.value ? { ...this.value } : emptyForm(this.typeId)
  }

  get isNew(): boolean {
    return this.value == null
  }

  // null = neutral (empty); true/false drive the validation styling.
  get codeIdState(): boolean | null {
    if (!this.form.codeId) return null
    return CODE_ID_REGEX.test(this.form.codeId)
  }

  private formOk(): boolean {
    if (!this.form.codeId || !this.form.name || !this.form.name.trim()) return false
    return CODE_ID_REGEX.test(this.form.codeId)
  }

  hideModal() {
    this.$bvModal.hide('UpsertCvValueModal')
  }

  private saveForm(): void {
    if (!this.formOk() || this.saving) return

    const orderNum = typeof this.form.orderNum === 'number' && !isNaN(this.form.orderNum)
      ? this.form.orderNum
      : null

    const payload: CvValue = {
      ...this.form,
      codeId: this.form.codeId.trim(),
      typeId: this.isNew ? this.typeId : this.form.typeId,
      name: (this.form.name || '').trim(),
      orderNum
    }

    const promise = this.isNew
      ? ApiClient.createCvValue(payload)
      : ApiClient.updateCvValue(payload.codeId, payload)

    this.saving = true
    promise
      .then((saved: CvValue) => {
        this.$emit('saved', saved)
        this.hideModal()
        this.form = emptyForm(this.typeId)
      })
      .catch((ex: Error) => {
        this.$bvToast.toast(ex.message, {
          title: this.$t('feedback.error_title_generic').toString(),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.saving = false
      })
  }
}
